import { MapPin, X } from 'lucide-react';
import type { Location } from '../types/campaign';

interface LocationListProps {
  locations: Location[];
  onRemove: (id: string) => void;
}

export default function LocationList({
  locations,
  onRemove,
}: LocationListProps) {
  if (locations.length === 0) {
    return (
      <div className="text-center py-8 border-2 border-dashed border-gray-700 rounded-lg">
        <MapPin className="mx-auto h-8 w-8 text-gray-600" />
        <p className="mt-2 text-sm text-text-muted">
          No locations selected. Search and add locations above.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {locations.map((location) => (
        <div
          key={location.id}
          className="flex items-center justify-between p-3 bg-brand-hover/30 rounded-lg border border-gray-700"
        >
          <div className="flex items-center gap-3">
            <MapPin className="h-5 w-5 text-text-muted" />
            <div>
              <p className="text-sm text-neutral-light">{location.name}</p>
              {location.state && (
                <p className="text-xs text-text-muted">{location.state}</p>
              )}
            </div>
          </div>
          <button
            onClick={() => onRemove(location.id)}
            className="p-1.5 hover:bg-brand-hover rounded-lg transition-colors"
            title="Remove location"
          >
            <X className="h-4 w-4 text-text-muted" />
          </button>
        </div>
      ))}
    </div>
  );
}
